// extracted by mini-css-extract-plugin
var _1 = "_stockOutApprovalTable-module__action-button";
var _2 = "_stockOutApprovalTable-module__action-button-container";
var _3 = "_stockOutApprovalTable-module__approve";
var _4 = "_stockOutApprovalTable-module__reject";
export { _1 as "action-button", _2 as "action-button-container", _3 as "approve", _4 as "reject" }
